import { authGuard, currentUserResolver, guestGuard } from '@rms/auth';
import { AppRoutes, LayoutComponent } from '@rms/layout';

import { langParamResolver } from './core/language-detection/lang-param.resolver';

export const appRoutes: AppRoutes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
    canActivate: [guestGuard],
    resolve: { lang: langParamResolver },
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
    canActivate: [guestGuard],
    resolve: { lang: langParamResolver },
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    canActivate: [guestGuard],
    resolve: { lang: langParamResolver },
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    resolve: { lang: langParamResolver, user: currentUserResolver },
    children: [
      {
        path: 'showcase',
        loadComponent: () => import('./pages/showcase').then((m) => m.ShowcaseComponent),
      },
      {
        path: 'home',
        loadComponent: () => import('./pages/home').then((m) => m.HomeComponent),
      },
      {
        path: 'partners',
        loadComponent: () => import('./pages/partners').then((m) => m.PartnersComponent),
      },
      {
        path: 'customers',
        loadComponent: () => import('./pages/customers').then((m) => m.CustomersComponent),
      },
      {
        path: 'team',
        loadComponent: () => import('./pages/team').then((m) => m.TeamComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile').then((m) => m.ProfileComponent),
      },
      {
        path: 'error',
        loadComponent: () => import('./pages/error').then((m) => m.ErrorComponent),
      },
      { path: '', pathMatch: 'full', redirectTo: 'showcase' },
    ],
  },
  { path: '**', redirectTo: '' },
];
